import { action, makeObservable, observable } from 'mobx';
import { isEmpty } from 'lodash';
import { deliveryService } from 'config/ioc';
import { FULFILLED, PENDING, REJECTED } from 'constants/actions';

const FILTER = {
  period: [],
  status: [],
  team: [],
  customers: [],
  constructions: [],
  offices: [],
};

class DeliveriesStore {
  fetchState;

  statusFetchState;

  shipments = [];

  deliveryStatuses = [];

  prevScroll = null;

  // храним в сторе информацию о выбранных фильтрах пока не готово АПИ для получения данных по списку id
  filters = FILTER;

  isFetchedFirstTime = true;

  constructor() {
    makeObservable(this, {
      fetchState: observable,
      statusFetchState: observable,
      shipments: observable.ref,
      deliveryStatuses: observable.ref,
      filters: observable,
      getShipments: action.bound,
      resetAllFilters: action.bound,
      setFilters: action.bound,
      getDeliveryStatuses: action.bound,
    });
  }

  async getShipments(filters) {
    this.fetchState = PENDING;
    try {
      const response = await deliveryService.getShipments(filters);
      const shipments = response.data.data.items;
      this.shipments = shipments;
      this.fetchState = FULFILLED;
      this.isFetchedFirstTime = false;
    } catch (e) {
      this.fetchState = REJECTED;
    }
  }

  resetAllFilters() {
    this.filters = { ...FILTER };
    this.getShipments(FILTER);
  }

  setFilters(filters) {
    this.filters = filters;
  }

  async getDeliveryStatuses() {
    this.statusFetchState = PENDING;

    if (!isEmpty(this.deliveryStatuses)) {
      return;
    }

    try {
      const response = await deliveryService.getDeliveryStatuses();
      this.deliveryStatuses = response.data.data.items;
      this.statusFetchState = FULFILLED;
    } catch (e) {
      this.statusFetchState = REJECTED;
    }
  }
}

const deliveriesStore = new DeliveriesStore();

export default deliveriesStore;
